// @ts-nocheck
export const URL = process.env.PUBLIC_URL + '/assets/characters/MageForAnimation.gltf'

export const useModel = (): GLTFResult => {
  const { nodes, materials } = useGLTF(URL) as GLTFResult
  Object.values(nodes).forEach(n => n.traverse(ch => (ch.type === 'Mesh' ? (ch.castShadow = true) : null)))
  return { nodes, materials }
}
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { Mesh } from 'three'

export type GLTFResult = GLTF & {
  nodes: {
    Cube3976: THREE.Mesh
    Cube3976_1: THREE.Mesh
    Cube3976_2: THREE.Mesh
    Cube011: THREE.Mesh
    Cube011_1: THREE.Mesh
    Cube011_2: THREE.Mesh
    Cube008: THREE.Mesh
    Cube008_1: THREE.Mesh
    Cube008_2: THREE.Mesh
    Cube008_3: THREE.Mesh
    Cube008_4: THREE.Mesh
    Cube017: THREE.Mesh
    Cube017_1: THREE.Mesh
    Cube021: THREE.Mesh
    Cube021_1: THREE.Mesh
    Cube021_2: THREE.Mesh
    Cube016: THREE.Mesh
    Cube016_1: THREE.Mesh
    Cube016_2: THREE.Mesh
    character_mageBody: THREE.Group
    character_mageArmRight: THREE.Group
    character_mageArnLeft: THREE.Group
    character_mageHair: THREE.Group
    character_mageHat: THREE.Group
    character_mageHead: THREE.Group
  }
  materials: {
    PurpleDark: THREE.MeshStandardMaterial
    Metal: THREE.MeshStandardMaterial
    WoodDark: THREE.MeshStandardMaterial
    Purple: THREE.MeshStandardMaterial
    BrownDark: THREE.MeshStandardMaterial
    Black: THREE.MeshStandardMaterial
    Red: THREE.MeshStandardMaterial
    PinkLight: THREE.MeshStandardMaterial
  }
}

export function Model(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF(URL) as GLTFResult
  return (
    <group {...props} dispose={null}>
      <group name="Animated_Group" userData={{ name: 'Animated_Group' }}>
        <group name="Animated_Character" userData={{ name: 'Animated_Character' }}>
          <group name="Body" userData={{ name: 'Body' }}>
            <group
              name="armLeft"
              position={[0.14, 0.69, 0]}
              rotation={[Math.PI / 2, -1.08, -Math.PI / 2]}
              userData={{ name: 'armLeft' }}
            >
              <group
                name="character_mageArnLeft"
                position={[-0.02, 0.16, -0.04]}
                rotation={[0.1, -1.37, 2.69]}
                userData={{ name: 'character_mageArnLeft' }}
              >
                <mesh
                  name="Cube3976"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube3976.geometry}
                  material={materials.PurpleDark}
                  userData={{ name: 'Cube3976' }}
                />
                <mesh
                  name="Cube3976_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube3976_1.geometry}
                  material={materials.Metal}
                  userData={{ name: 'Cube3976_1' }}
                />
                <mesh
                  name="Cube3976_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube3976_2.geometry}
                  material={materials.WoodDark}
                  userData={{ name: 'Cube3976_2' }}
                />
              </group>
            </group>
            <group
              name="armRight"
              position={[-0.14, 0.69, 0]}
              rotation={[-Math.PI / 2, -1.08, Math.PI / 2]}
              userData={{ name: 'armRight' }}
            >
              <group
                name="character_mageArmRight"
                position={[0.01, 0.1, 0.04]}
                rotation={[2.96, -1.07, 0.36]}
                userData={{ name: 'character_mageArmRight' }}
              >
                <mesh
                  name="Cube011"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube011.geometry}
                  material={materials.PurpleDark}
                  userData={{ name: 'Cube011' }}
                />
                <mesh
                  name="Cube011_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube011_1.geometry}
                  material={materials.Metal}
                  userData={{ name: 'Cube011_1' }}
                />
                <mesh
                  name="Cube011_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube011_2.geometry}
                  material={materials.WoodDark}
                  userData={{ name: 'Cube011_2' }}
                />
              </group>
            </group>
            <group name="character_mageBody" userData={{ name: 'character_mageBody' }}>
              <mesh
                name="Cube008"
                castShadow
                receiveShadow
                geometry={nodes.Cube008.geometry}
                material={materials.PurpleDark}
                userData={{ name: 'Cube008' }}
              />
              <mesh
                name="Cube008_1"
                castShadow
                receiveShadow
                geometry={nodes.Cube008_1.geometry}
                material={materials.Purple}
                userData={{ name: 'Cube008_1' }}
              />
              <mesh
                name="Cube008_2"
                castShadow
                receiveShadow
                geometry={nodes.Cube008_2.geometry}
                material={materials.Metal}
                userData={{ name: 'Cube008_2' }}
              />
              <mesh
                name="Cube008_3"
                castShadow
                receiveShadow
                geometry={nodes.Cube008_3.geometry}
                material={materials.BrownDark}
                userData={{ name: 'Cube008_3' }}
              />
              <mesh
                name="Cube008_4"
                castShadow
                receiveShadow
                geometry={nodes.Cube008_4.geometry}
                material={materials.WoodDark}
                userData={{ name: 'Cube008_4' }}
              />
            </group>
            <group name="Head" position={[0, 0.71, 0]} userData={{ name: 'Head' }}>
              <group name="character_mageHair" position={[0, 0.07, 0]} userData={{ name: 'character_mageHair' }}>
                <mesh
                  name="Cube017"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube017.geometry}
                  material={materials.Black}
                  userData={{ name: 'Cube017' }}
                />
                <mesh
                  name="Cube017_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube017_1.geometry}
                  material={materials.Red}
                  userData={{ name: 'Cube017_1' }}
                />
              </group>
              <group name="character_mageHat" position={[0, 0.88, -0.02]} userData={{ name: 'character_mageHat' }}>
                <mesh
                  name="Cube021"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube021.geometry}
                  material={materials.PurpleDark}
                  userData={{ name: 'Cube021' }}
                />
                <mesh
                  name="Cube021_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube021_1.geometry}
                  material={materials.BrownDark}
                  userData={{ name: 'Cube021_1' }}
                />
                <mesh
                  name="Cube021_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube021_2.geometry}
                  material={materials.Metal}
                  userData={{ name: 'Cube021_2' }}
                />
              </group>
              <group name="character_mageHead" userData={{ name: 'character_mageHead' }}>
                <mesh
                  name="Cube016"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube016.geometry}
                  material={materials.PinkLight}
                  userData={{ name: 'Cube016' }}
                />
                <mesh
                  name="Cube016_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube016_1.geometry}
                  material={materials.Black}
                  userData={{ name: 'Cube016_1' }}
                />
                <mesh
                  name="Cube016_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube016_2.geometry}
                  material={materials.Black}
                  userData={{ name: 'Cube016_2' }}
                />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload(URL)
